/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import _ from 'lodash';
import { arrayMove } from '../../../../SharedModules/CommonUtilities/commonUtilities';
import * as actionTypes from './ActionTypes';

const axiosPayLoad = {
  checkbox: [],
  contactAnomaliesObj: {},
  tabValue: 'one',
  multipleSavePayloadAll: [],
};

const reducer = (state = axiosPayLoad, action) => {
  switch (action.type) {
    case actionTypes.INPUT_FIELD_VALUE_ACTION:
      return { ...state, getInputValue: action.payloadInputVal };
    case actionTypes.CONTACT_ANOMALIES_TAB_DATA:
      return {
        ...state,
        contactAnomaliesObj: action.contactAnomaliesObj,
      };
    case actionTypes.GET_TAB_VALUE:
      return { ...state, tabValue: action.payload };
    case actionTypes.MULTIPLE_SAVE_DATA:
      if (action.savePayload && action.savePayload.length === 0) {
        return {
          ...state,
          multipleSavePayloadAll: action.savePayload,
        };
      } else {
        return {
          ...state,
          multipleSavePayloadAll: [
            ...state.multipleSavePayloadAll,
            action.savePayload,
          ],
        };
      }
    case actionTypes.GET_SEARCH_CONTACT_ANOMALIES_BY_CRITERIA_LIST:
      return {
        ...state,
        contactAnomaliesData: action.searchContactAnomliesByCriteriaList,
      };
    case actionTypes.GET_SEARCH_COPY_CONTACT_ANOMALIES_BY_CRITERIA_LIST:
      return {
        ...state,
        copyContactAnomaliesData:
          action.searchCopyContactAnomliesByCriteriaList,
      };
    case actionTypes.GET_SEARCH_CONTRACT_BY_CRITERIA_LIST:
      return {
        ...state,
        contractAnomaliesData: action.searchContractByCriteriaList,
      };
    case actionTypes.GET_SEARCH_MFG_BY_CRITERIA_LIST:
      return { ...state, MFGAnomaliesData: action.searchMfgByCriteriaList };
    case actionTypes.GET_SEARCH_CODE_VALUE_LONG_DESC:
      return {
        ...state,
        needAttCodeValueAnomaliesData: action.searchNeedsAttCodeByCriteriaList,
      };
    case actionTypes.SAVE_CONTACT:
      return {
        ...state,
        saveContactAnomaliesData: action.saveContactAnomalies,
      };
    case actionTypes.HANDLE_SUCCESS_MESSAGE_FOR_CONTACT_ANOMALIES:
      return { ...state, successMessageInRedux: action.successMessage };
    case actionTypes.HANDLE_ERROR_MSG_CA:
      return { ...state, errorMessageInRedux: action.payloadErr };
    default:
      return state;
  }
};

export default reducer;
